import { useEffect } from 'react';
import { createPortal } from 'react-dom';

const Z_INDEX = 9999;

/**
 * Mobile: bottom sheet with option buttons + Cancel.
 * options: [{ label, icon: ReactNode, onClick, danger?: boolean }]
 */
export default function OptionsBottomSheet({ open, onClose, options = [], title }) {
  useEffect(() => {
    if (!open) return;
    const onEscape = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onEscape);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onEscape);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  const content = (
    <>
      <div
        className="fixed inset-0 bg-black/40 z-[9998]"
        style={{ zIndex: Z_INDEX - 1 }}
        onClick={onClose}
        aria-hidden
      />
      <div
        className="fixed left-0 right-0 bottom-0 z-[9999] bg-white dark:bg-gray-800 rounded-t-2xl shadow-xl border-t border-gray-200 dark:border-gray-700 pb-safe"
        style={{ zIndex: Z_INDEX }}
        role="dialog"
        aria-modal="true"
        aria-label={title || 'Opcije'}
      >
        <div className="pt-3 pb-2">
          <div className="w-10 h-1 rounded-full bg-gray-300 dark:bg-gray-600 mx-auto" />
        </div>
        {title && (
          <p className="px-4 py-2 text-sm font-medium text-gray-500 dark:text-gray-400">{title}</p>
        )}
        <div className="max-h-[70vh] overflow-y-auto py-2">
          {options.map((opt, i) => (
            <button
              key={i}
              type="button"
              onClick={() => { opt.onClick?.(); onClose(); }}
              className={`w-full flex items-center gap-3 px-4 py-3 text-left text-base ${
                opt.danger
                  ? 'text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20'
                  : 'text-gray-900 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-700'
              }`}
            >
              {opt.icon && <span className="flex-shrink-0 text-xl">{opt.icon}</span>}
              {opt.label}
            </button>
          ))}
        </div>
        <div className="p-3 border-t border-gray-100 dark:border-gray-700">
          <button
            type="button"
            onClick={onClose}
            className="w-full py-3 rounded-xl font-semibold text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600"
          >
            Otkaži
          </button>
        </div>
      </div>
    </>
  );

  return createPortal(content, document.body);
}
